<template>
  <div class="main-body">
    <div class="header">志愿者列表</div>
    <div class="out">

      <div class="search2">

        <div style="float:right">
          <el-input placeholder="输入名称" v-model="name" clearable style="width:120px;margin-right:10px"></el-input>
          <el-select v-model="status" placeholder="选择申请状态" style="width:150px;margin-right:10px">
            <el-option
                v-for="item in statusArr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
                        placeholder="请选择所属区域" v-on:getZoneValue="getZoneValue" :value='zoneCode'
                        style="width:200px;margin-right:10px"></elSelectTree>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" border>

        <el-table-column prop="name" label="老人姓名"></el-table-column>
        <el-table-column prop="age" label="年龄"></el-table-column>
        <el-table-column prop="gender" label="性别"></el-table-column>
        <el-table-column prop="phone" label="手机号"></el-table-column>
        <el-table-column prop="integration" label="积分"></el-table-column>

        <el-table-column label="志愿者状态" >
          <template slot-scope="scope">
            <span v-if="scope.row.statusVolunteer == 1">申请中</span>
            <span v-if="scope.row.statusVolunteer == 2">已通过</span>
            <span v-if="scope.row.statusVolunteer == 3">被驳回</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="250">
          <template slot-scope="scope">
            <el-button v-if="scope.row.statusVolunteer==1" size="mini" type="primary" @click="handlePass(scope.$index, scope.row)">通过</el-button>
            <el-button v-if="scope.row.statusVolunteer==1" size="mini" @click="handleReject(scope.$index, scope.row)">驳回</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

  </div>
</template>

<script>

import Add from "./Add";
import Edit from "./Edit";
import elSelectTree from "@/components/ElSelectTree"

import {timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";
import {hex_md5,hex_md5_with_china} from "@/common/Base64MD5";


export default {
  name: "Page",

  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data(){
    return{

      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,


      showModalAdd:false,
      showModalEdit:false,


      th:0,

      status:1,
      statusArr: [
        {
          value: 1, label: '申请中'
        }, {
          value: 2, label: '已通过'
        }, {
          value: 3, label: '已驳回'
        }
      ],

      zoneValue: [],
      zoneCode: '',
      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        label: 'name',
        children: 'listZoneDTO'
      },

      name:'',

    }
  },
  created(){
    this.getZoneList();

    this.th = this.$store.state.tableHeight;
  },
  components:{
    Add,Edit,elSelectTree
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    getZoneValue(val) {
      this.zoneCode = val
    },

    getZoneList:function (){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              var data = JSON.stringify(response.data.data);
              data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
              this.zoneValue = data;
              //this.zoneCode=data[0].zoneCode;
              this.getList();
            } else if (response.data.error == 1) {
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },



    search(){
      this.currentPage = 1;
      this.getList();
    },

    getList(){

      let data={
        timeStr:timeStr,
        sign:"",
        staffCode: getStaffCode(),
        pageIndex:this.currentPage,
        pageSize:this.pageSize,
        statusVolunteer:this.status,
        zoneCode:this.zoneCode,
        name:this.name,
      };

      data.sign = "";
      data.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(data) + "&key="+this.$signKey)


      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Volunteer/CmdPage',
        data: data,
      }).then( (response)=> {
        console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },



    handlePass(index, row) {
      this.$confirm(' 确认通过吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deal(2,row.elderlyCode);
      }).catch(e=>e)

    },
    handleReject(index, row) {
      this.$confirm(' 确认驳回吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deal(3,row.elderlyCode);
      }).catch(e=>e)

    },

    deal(status,elderlyCode){

      let data={
        timeStr:timeStr,
        sign:"",
        status:status,
        elderlyCode:elderlyCode,
      };

      data.sign = "";
      data.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(data) + "&key="+this.$signKey)

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Volunteer/Verify',
        data: data,
      }).then( (response)=> {
        console.log(response);
        if(response.data.error == 0){
          this.search();
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },



  }
}
</script>

<style scoped>

</style>
